import React from "react";
import { Navigate } from "react-router-dom";

import Configuration from "../../foundation/Configuration";
import Utilities from "../../foundation/Utility";
import { connect } from "react-redux";
import { IAppState } from "../../state/Store";
import { initialiseUserDetails } from "../../state/system/Session";
import { initialiseSchoolDetails } from "../../state/core/School";
import AppState from "../../foundation/AppState";
import School from "../../types/core/School";
import User from "../../types/core/User";
import { AuthJWTPayload } from "../../types/system/AuthJWT";
import { KnownSettings, setSetting } from "../../state/system/Settings";
import { AppContext } from "../../types/system/AppContext";

import userIcon from "../../graphics/profile.svg";

import "./UserMenu.scss";

interface UserMenuProps {
    jwt: AuthJWTPayload;
    settings: KnownSettings;
    user?: User;
    profilePicture: string;
    school?: School;
    schools?: School[];
    pins?: number[];
    initialiseUserDetails?: Function;
    initialiseSchoolDetails?: Function;
    shouldClose: Function;
    navigate: (path: string) => void;
}

interface UserMenuState {
    settings: KnownSettings;
    schoolFilter: string;
    shouldNavigate: boolean;
}

class UserMenu extends React.Component<UserMenuProps, UserMenuState> {
    static contextType = AppContext;
    context!: React.ContextType<typeof AppContext>;

    state = {
        settings: null,
        schoolFilter: "",
        shouldNavigate: false,
    };

    static getDerivedStateFromProps(
        props: UserMenuProps,
        state: UserMenuState,
    ): UserMenuState {
        return {
            settings: new KnownSettings(props.settings),
            schoolFilter: state.schoolFilter,
            shouldNavigate: state.shouldNavigate,
        };
    }

    constructor(props: UserMenuProps) {
        super(props);

        props.initialiseUserDetails();
    }

    setAllowSupport(value: boolean) {
        setSetting("supportAccess", value ? "true" : "false");
    }
    setSchoolFilter(value: string) {
        this.setState({
            schoolFilter: value,
        });
    }
    endImpersonate() {}
    profileClick() {
        this.context.navigate("/UserProfile");
        this.props.shouldClose();
    }
    logoutClick() {
        AppState.reset();

        var authPath = `${Configuration.authenticationPath}/Logout/${Configuration.applicationToken}`;

        document.location = `${authPath}?jwtrequest=${Utilities.getAuthJWT(
            authPath,
        )}`;
    }
    schoolClick(school: School) {}
    pinClick(school: School) {}

    render() {
        return (
            <div className="user-details-container">
                <div className="user-menu-container">
                    <div className="user-menu-display">
                        <div className="user-details">
                            {this.props.jwt.impersonating !==
                                Number(this.props.jwt.sub) && (
                                <span
                                    onClick={this.endImpersonate}
                                    className="impersonate"
                                    tabIndex={0}
                                    data-tip="This user session is being impersonated by {{user.Impersonator}}, click this to end the impersonation session">
                                    <i className="fa-solid fa-reply"></i>
                                    <i className="fa-solid fa-clipboard-user"></i>
                                    <span>{this.props.user?.impersonator}</span>
                                </span>
                            )}

                            <span className="detail">
                                <span className="profile-image">
                                    <img
                                        src={
                                            this.props.profilePicture?.toDataUrl() ??
                                            userIcon
                                        }
                                        alt="Profile"
                                        onError={e => {
                                            e.currentTarget.src = userIcon;
                                        }}
                                    />
                                </span>

                                <span className="information">
                                    {this.props.jwt.salutation && (
                                        <span className="name">
                                            {this.props.jwt.salutation}
                                        </span>
                                    )}

                                    {this.props.jwt.given_name && (
                                        <span className="name">
                                            {this.props.jwt.given_name}
                                        </span>
                                    )}

                                    {this.props.jwt.family_name && (
                                        <span className="name">
                                            {this.props.jwt.family_name}
                                        </span>
                                    )}

                                    {this.props.jwt.roles && (
                                        <span
                                            className="groups"
                                            data-tip={this.props.jwt.roles}>
                                            {this.props.jwt.roles}
                                        </span>
                                    )}

                                    <button
                                        className="profile-link link-btn"
                                        onClick={() => this.profileClick()}>
                                        <i>account_box</i> Profile
                                    </button>

                                    <label
                                        className="support checkbox has-label"
                                        data-html={true}
                                        data-tip={`<span style='color:#${
                                            this.state.settings.supportAccess
                                                ? "67c267"
                                                : "c26767"
                                        }'>${
                                            this.state.settings.supportAccess
                                                ? "On"
                                                : "Off"
                                        }</span>: Timetabling Solutions support staff may access your account, any changes made to your data by Timetabling Solutions staff will be reflected in the change logs`}>
                                        <input
                                            type="checkbox"
                                            checked={
                                                this.state.settings
                                                    .supportAccess
                                            }
                                            onChange={() =>
                                                this.setAllowSupport(
                                                    !this.state.settings
                                                        .supportAccess,
                                                )
                                            }
                                        />
                                        <span className="checkmark"></span>
                                        <span className="text">
                                            Permit Support Access
                                        </span>
                                    </label>
                                </span>
                            </span>
                        </div>

                        <div className="user-menu-scroll-container">
                            <span className="user-menu-scroll-title">
                                My Schools
                                <button
                                    className="user-menu-logout"
                                    onClick={this.logoutClick}>
                                    Logout
                                </button>
                            </span>

                            <div className="user-menu-school-search-container">
                                <input
                                    type="text"
                                    autoFocus
                                    className="user-menu-school-search-box"
                                    placeholder="Filter Schools..."
                                    value={this.state.schoolFilter}
                                    onChange={e =>
                                        this.setSchoolFilter(e.target.value)
                                    }
                                />
                            </div>

                            <div className="user-menu-scroll">
                                <div className="user-menu-scroll-inner">
                                    <ul className="user-menu">
                                        {this.props.schools
                                            .filter(
                                                entry =>
                                                    this.props.pins?.includes(
                                                        entry.id,
                                                    ) &&
                                                    entry.name
                                                        .toLowerCase()
                                                        .indexOf(
                                                            this.state.schoolFilter.toLowerCase(),
                                                        ) >= 0,
                                            )
                                            .map((entry, index) => {
                                                return (
                                                    <li
                                                        key={index}
                                                        className={`${
                                                            this.props.school
                                                                .id === entry.id
                                                                ? "selected"
                                                                : ""
                                                        }`}>
                                                        <div
                                                            onClick={() =>
                                                                this.schoolClick(
                                                                    entry,
                                                                )
                                                            }
                                                            tabIndex={0}
                                                            data-tip={
                                                                entry.name
                                                            }
                                                            data-place="left">
                                                            <i className="fa-solid blue fa-school"></i>
                                                            <span>
                                                                <span>
                                                                    {entry.name}
                                                                </span>
                                                                <span>
                                                                    {
                                                                        entry
                                                                            .address
                                                                            ?.city
                                                                    }{" "}
                                                                    {
                                                                        entry
                                                                            .address
                                                                            ?.state
                                                                    }{" "}
                                                                    {
                                                                        entry
                                                                            .address
                                                                            ?.country
                                                                    }
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <span
                                                            className="pin"
                                                            onClick={() =>
                                                                this.pinClick(
                                                                    entry,
                                                                )
                                                            }>
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                        </span>
                                                    </li>
                                                );
                                            })}

                                        {this.props.schools
                                            .filter(
                                                entry =>
                                                    !this.props.pins?.includes(
                                                        entry.id,
                                                    ) &&
                                                    entry.name
                                                        .toLowerCase()
                                                        .indexOf(
                                                            this.state.schoolFilter.toLowerCase(),
                                                        ) >= 0,
                                            )
                                            .map((entry, index) => {
                                                return (
                                                    <li
                                                        key={index}
                                                        className={`${
                                                            this.props.school
                                                                .id === entry.id
                                                                ? "selected"
                                                                : ""
                                                        }`}>
                                                        <div
                                                            onClick={() =>
                                                                this.schoolClick(
                                                                    entry,
                                                                )
                                                            }
                                                            tabIndex={0}
                                                            data-tip={
                                                                entry.name
                                                            }
                                                            data-place="left">
                                                            <i className="blue">
                                                                location_city
                                                            </i>
                                                            <span>
                                                                <span>
                                                                    {entry.name}
                                                                </span>
                                                                <span>
                                                                    {
                                                                        entry
                                                                            .address
                                                                            ?.city
                                                                    }{" "}
                                                                    {
                                                                        entry
                                                                            .address
                                                                            ?.state
                                                                    }{" "}
                                                                    {
                                                                        entry
                                                                            .address
                                                                            ?.country
                                                                    }
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <span
                                                            className="pin unpinned"
                                                            onClick={() =>
                                                                this.pinClick(
                                                                    entry,
                                                                )
                                                            }>
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                        </span>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { school, settings } = state.db;
    const { session } = state.session;

    return {
        jwt: AppState.jwt,
        settings: settings.settings,
        user: session.user,
        profilePicture: session.profilePicture,
        school: school.school,
        schools: school.schools,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        initialiseUserDetails: () => dispatch(initialiseUserDetails()),
        initialiseSchoolDetails: () => dispatch(initialiseSchoolDetails()),
        navigate: path => dispatch(Navigate({ to: path })),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu);
